import { render, staticRenderFns } from "./detail_jbxx_edit.vue?vue&type=template&id=f24a1c84&scoped=true&"
import script from "./detail_jbxx_edit.vue?vue&type=script&lang=js&"
export * from "./detail_jbxx_edit.vue?vue&type=script&lang=js&"
import style0 from "./detail_jbxx_edit.vue?vue&type=style&index=0&id=f24a1c84&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f24a1c84",
  null
  
)

export default component.exports